import type { OtherAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";
import { calculateOwnership } from "../genericCalculations/ownership";

export const otherBalance = (userProduct: OtherAsset) => {
  const balance = userProduct?.currentValue || 0;
  const ownership = userProduct?.ownership || 0;

  return calculateOwnership(balance, ownership);
};

export const convertOtherBalance = (
  userProduct: OtherAsset,
  currencies: {
    baseCurrency: Fiat;
    currentCurrency: Fiat;
  }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  const balance = otherBalance(userProduct);

  return convertCurrency(balance, baseCurrency, currentCurrency);
};
